var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"upgrade-tier-list"},_vm._l((_vm.tiers),function(tier){return _c('li',{staticClass:"upgrade-plan-item"},[_c('upgrade-plan',_vm._b({},'upgrade-plan',{tier: tier, features: _vm.features, view: _vm.view, onSubmit: _vm.onSubmit},false))],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638ff1cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./lib/brave-upgrade/components/tier-list.vue
// module id = DAk4
// module chunks = 0